export default {
    install(Vue, option) {
        Vue.prototype.$common = new (function () {
            const isDev = (window.location.hostname).includes('localhost') || option.config.VUE_APP_RUN_MODE === 'DEV';

            this.log = value => {
                if (isDev) {
                    console.log(value)
                }
            }

            this.error = value => {
                if (isDev) {
                    console.error(value)
                }
            }

            this.logData = (data, title = '') => {
                if (isDev) {
                    if (title !== '') {
                        console.log(`------------- ${title} -------------`);
                    }
                    console.log(JSON.parse(JSON.stringify(data)));
                }
            }

            this.diffQuery = (newQuery, oldQuery) => {
                Object.keys(newQuery).forEach(key => {
                    if (newQuery[key] === null ||
                        newQuery[key] === '' ||
                        key === 'searchType' && !newQuery['search']
                    ) {
                        delete newQuery[key];
                    }
                })

                if (Object.keys(newQuery).length !== Object.keys(oldQuery).length) {
                    return newQuery;
                }

                let diff = false;
                const keys = Object.keys(newQuery);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    if (newQuery[key] != oldQuery[key]) {
                        diff = true;
                        break;
                    }
                }

                if (diff) {
                    return newQuery;
                } else {
                    return null;
                }
            }

            // ============ File Function =================
            this.getAcceptFileFormat = types => {
                let fileFormatStr = [];
                let fileFormatArr = [];

                if (types.includes('image')) {
                    fileFormatStr = [...fileFormatStr, 'image/jpeg', 'image/jpg', 'image/png'];
                    fileFormatArr = [...fileFormatArr, 'png', 'jpeg', 'jpg'];
                }

                if (types.includes('video') || types.includes('vimeo')) {
                    fileFormatStr = [...fileFormatStr, 'video/mp4', 'video/webm'];
                    fileFormatArr = [...fileFormatArr, 'mp4', 'webm'];
                }

                if (types.includes('pdf')) {
                    fileFormatStr = [...fileFormatStr, 'application/pdf'];
                    fileFormatArr = [...fileFormatArr, 'pdf'];
                }

                if (fileFormatArr.length > 0) {
                     return {
                        formatStr: fileFormatStr.join(','),
                        formatArr: fileFormatArr
                    }
                }

                return null;
            }
        })()
    }
}